import {observer} from 'mobx-react-lite'
import React from 'react'
import {FilePreview} from '@common/file-preview'
import {Icon} from '@components/common/base/icon'
import {TwCloseIcon, TwListItem, TwSelected} from './containers'
import {useProfileSkinStore} from './profile-skin-store'

interface Props {
  skin: string
  custom: boolean
}

export const OurSkinItem = observer(({skin, custom}: Props) => {
  const [state, store] = useProfileSkinStore()
  const selected = skin === state.tabBgSkin

  return (
    <div className="relative group">
      <TwListItem
        $selected={selected}
        style={{
          backgroundImage: `url(${FilePreview.getBackgroundPreviewUrl(skin)})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }}
        onClick={() => store.setTabBgSkin(skin)}
      />
      {custom && (
        <TwCloseIcon onClick={e => store.deleteSkin(skin, e)}>
          <Icon
            icon={'IconCustomClose'}
            color={'generic-white'}
            style={{transform: 'scale(0.8)'}}
          />
        </TwCloseIcon>
      )}

      {selected && <TwSelected />}
    </div>
  )
})
